module.exports = __webpack_public_path__ + "img/04-bk-city-clouds.ccc11545.svg";